import styled from 'styled-components';
import NavLink from '../link';

const StyledChildLink = styled(NavLink).attrs(() => ({ state: { via: 'ChildLink' } }))`
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  color: ${({ theme }) => theme.fontColor};
`;

export default StyledChildLink;
